



























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import UserReportTableFondocytComponent from '@/components/user-report/user-report-table-fondocyt.vue';
import { ProposalState } from '@/enums/ProposalState';

@Component({
  components : {
    UserReportTableFondocytComponent
  }
})
export default class ProposalUserReportFondocyt extends GenericBTable<Annoucement> 
{
  enviadoFC: ProposalState = ProposalState.EnviadoFC;
  devueltoFC: ProposalState = ProposalState.DevueltoFC;
  aprobadoFC: ProposalState = ProposalState.AprobadoFC;
  refreshTable: number = 0;
  
  reloadTable() {
    this.refreshTable += 1;
  }

}
